// extracted by mini-css-extract-plugin
module.exports =  {"root":"ODUiBBsdMOv1keqPJOVi"};